goog.provide("shadow.js.shim.module$remark_gfm");
goog.provide("module$shadow_js_shim_module$remark_gfm");
shadow.js.shim.module$remark_gfm = shadow.js.nativeProvides["remark-gfm"] = shadow$bridge("remark-gfm");
module$shadow_js_shim_module$remark_gfm.default = shadow.js.shim.module$remark_gfm;
